// extracted by mini-css-extract-plugin
export default {"FeatureContainer":"FeaturesList_FeatureContainer__GiUu1"};